import { Volume2, VolumeOff } from "lucide-react";
import { useAudio } from "../Stores/useAudio";
import { useEffect, useRef } from "react";

export const AudioButton = () => {
  const { audioURL, audioOff, setAudioStatus } = useAudio();

  // Cache Audio instances by URL
  const audioMapRef = useRef({});

  // Currently playing Audio
  const currentAudioRef = useRef(null);

  // 1) Preload & start a new track whenever audioURL changes
  useEffect(() => {
    if (audioURL.length === 0) return;
    const map = audioMapRef.current;

    // Preload each URL once
    audioURL.forEach((url) => {
      if (!map[url]) {
        const a = new Audio(url);
        a.preload = "auto";
        // a.loop = true;   ← remove this line so it doesn't loop
        a.load();
        map[url] = a;
      }
    });

    // Pick a random preloaded track
    const randomURL =
      audioURL[Math.floor(Math.random() * audioURL.length)];
    const audio = map[randomURL];

    currentAudioRef.current = audio;
    audio.currentTime = 0;
    audio.muted = audioOff;
    audio
      .play()
      .catch((err) => console.error("Audio play error:", err));

    // Cleanup on unmount: pause and reset
    return () => {
      Object.values(map).forEach((a) => {
        a.pause();
        a.currentTime = 0;
      });
    };
  }, [audioURL]);

  // 2) Mute/unmute without pausing
  useEffect(() => {
    const audio = currentAudioRef.current;
    if (audio) {
      audio.muted = audioOff;
    }
  }, [audioOff]);

  return (
    <div className="right-10 bottom-10 fixed z-50">
      <button
        onClick={() => setAudioStatus(!audioOff)}
        className="bg-[#0f0f0f90] p-2 rounded-full"
      >
        {audioOff ? <VolumeOff color="white" /> : <Volume2 color="white" />}
      </button>
    </div>
  );
};
